export default __webpack_public_path__ + "static/media/endGameMusic.1b337c87.mp3";